import {useRef} from "react";


export const useDivRef = () =>
  useRef<HTMLDivElement>(document.createElement('div'));
